import { css } from 'config/emotionCss';
import colors from 'config/theme/colors';

const dropdownMenuItemStyle = css`
  padding: 8px 12px !important;
  margin-bottom: 2px !important;
  border-radius: 4px !important;

  &:hover {
    background-color: ${colors['@primary-color-extra-xx']};
  }

  .anticon,
  i[class*='fb-icon'] {
    font-size: 18px;
    margin-right: 8px;
  }

  > .ant-dropdown-menu-title-content {
    * {
      font-weight: 500;
      color: ${colors['@text-color-secondary']};
    }

    > a {
      display: flex;
      align-items: center;
    }
  }

  &-selected {
    background-color: ${colors['@item-hover-bg']};
    *,
    *:hover {
      background-color: transparent !important;
      color: ${colors['@primary-color']} !important;
    }
  }
`;

export const overlayStyle = css`
  &:not(.user-profile) {
    margin-top: 8px !important;
  }
  .ant-dropdown-menu-item-group {
    border-bottom: 0.5px solid ${colors['@grey-20']};

    .ant-dropdown-menu-item-group-title {
      display: none;
    }

    .ant-dropdown-menu-item-group-list {
      margin: 8px;
    }

    &:last-child {
      border-bottom: none;
    }
  }

  .ant-dropdown-menu-item {
    ${dropdownMenuItemStyle}
  }

  > .ant-dropdown-menu-item {
    margin: 0 4px 2px 4px !important;
    &:first-child {
      margin-top: 4px !important;
    }
  }
  .ant-dropdown-menu-item:hover {
    background: ${colors['@primary-color-extra-xx']} !important;
  }
  .ant-dropdown-menu-item-selected {
    background: ${colors['@item-hover-bg']} !important;
  }
`;

export const overlayRootStyle = css`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap:8px 12px;
`;
